/* ============================================================
   SBSL — Recharge Subscription Widget helpers
   Hide the in-widget one-time tier. CSS can't isolate it (no unique part, and
   :last-child on the forwarded part isn't honored), so reach into the open
   shadow roots and hide the option whose label is the one-time purchase.
   Order-independent and re-applied if the widget re-renders.
   One-time is offered via a separate link below the buy box.
   ============================================================ */
(function () {
  // The one-time row is labeled "One Bottle" on this store (not "One-time").
  // Match either wording so it stays hidden if the label changes.
  var ONE_TIME_RE = /one[\s-]*(bottle|time)/i;

  function applyHide(optionsRoot) {
    var options = optionsRoot.querySelectorAll('.rc-quantity-upsell-option');
    var found = false;
    options.forEach(function (opt) {
      if (ONE_TIME_RE.test(opt.textContent || '')) {
        opt.style.display = 'none';
        found = true;
      }
    });
    return found;
  }

  function init() {
    var host = document.querySelector('.single-pro recharge-subscription-widget');
    if (!host || !host.shadowRoot) return false;
    var inner = host.shadowRoot.querySelector('recharge-quantity-upsell');
    if (!inner || !inner.shadowRoot) return false;
    if (!applyHide(inner.shadowRoot)) return false;
    // Re-hide if Recharge re-renders the options (e.g. on variant change).
    new MutationObserver(function () { applyHide(inner.shadowRoot); })
      .observe(inner.shadowRoot, { childList: true, subtree: true });
    return true;
  }

  // The widget hydrates asynchronously — retry until the options exist (~10s).
  var tries = 0;
  var timer = setInterval(function () {
    if (init() || ++tries > 40) clearInterval(timer);
  }, 250);
})();

/* One-time purchase link — adds the current variant with NO selling plan (so
   it's a one-time buy). Recharge's /cart/add.js fetch interceptor opens the
   slide-out cart, same as the quick-add flow. */
(function () {
  document.addEventListener('click', function (e) {
    var link = e.target.closest('.onetime-purchase-link');
    if (!link) return;
    e.preventDefault();

    // Prefer the product form's live variant id (updates on variant change),
    // fall back to the value rendered into the link.
    var variantId = link.getAttribute('data-variant-id');
    var idInput = document.querySelector('#buy-box [name="id"]');
    if (idInput && idInput.value) variantId = idInput.value;
    if (!variantId) return;

    link.setAttribute('aria-busy', 'true');
    var body = new FormData();
    body.append('id', variantId);
    body.append('quantity', 1);

    fetch('/cart/add.js', { method: 'POST', body: body })
      .then(function (r) { return r.json(); })
      .then(function () {
        // Keep the header count badge in sync (Recharge opens the drawer itself).
        fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          document.querySelectorAll('.cart_qty_cls').forEach(function (el) {
            el.textContent = cart.item_count;
            el.classList.toggle('hidden-count', cart.item_count === 0);
          });
        });
      })
      .catch(function (err) { console.error('One-time add error:', err); })
      .finally(function () { link.removeAttribute('aria-busy'); });
  });
})();

/* Subscribe ATC → auto-apply the first-order discount code. The Recharge drawer
   (app slide-out) renders off the /cart/add response and can't be refreshed
   theme-side, so the code must be in the session BEFORE the add. Apply it once,
   as soon as Subscribe is the selected plan (the default), so the cart already
   carries it when Recharge opens the drawer. One-time scoping is enforced on the
   discount in admin (a one-time line can't claim a subscription-scoped code). */
(function () {
  var card = document.getElementById('sbsl-onetime-price');
  var CODE = card && card.getAttribute('data-subscribe-discount-code');
  if (!CODE) return;                       // blank setting → disabled, graceful
  var applied = false;                     // idempotent per page load
  var tries = 0;
  var timer = setInterval(function () {
    var form = document.querySelector('.AddToCartForm_id');
    var sp = form && new FormData(form).get('selling_plan');
    if (sp) {                              // subscribe is the selected plan
      applied = true;
      clearInterval(timer);
      fetch('/discount/' + encodeURIComponent(CODE),
            { credentials: 'same-origin', redirect: 'follow' })
        .catch(function (err) { console.error('subscribe discount apply failed:', err); });
    } else if (++tries > 60) {             // ~15s cap (250ms * 60), like the widget retry
      clearInterval(timer);
    }
  }, 250);
})();

/* ============================================================
   STANDARD widget — append the per-order savings to the "Subscribe To Save"
   title (Recharge's title field has no price variable). Result:
   "Subscribe To Save $19.47 per order". Recomputes when the frequency changes.
   ============================================================ */
(function () {
  function deep(root, pred, out) {
    out = out || [];
    root.querySelectorAll('*').forEach(function (e) {
      if (pred(e)) out.push(e);
      if (e.shadowRoot) deep(e.shadowRoot, pred, out);
    });
    return out;
  }
  function partHas(e, s) { var p = e.getAttribute && e.getAttribute('part'); return p && p.indexOf(s) !== -1; }
  function priceOf(el) {
    if (!el) return NaN;
    var m = el.textContent.match(/[\d,]+\.\d{2}/);
    return m ? parseFloat(m[0].replace(/,/g, '')) : NaN;
  }
  // Per-day price line (Grüns-style), below the price. One order = ~1 month of
  // product, so divide the sale price by 30. Injected into the flex __prices wrapper
  // as a full-width row (order:3) so it sits under the price. Idempotent (observer-safe).
  var SBSL_SUPPLY_DAYS = 30;
  function injectPerDay(wrap, salePrice) {
    if (!wrap || !wrap.querySelector || !(salePrice > 0)) return;
    var txt = '$' + (salePrice / SBSL_SUPPLY_DAYS).toFixed(2) + '/day';
    var ex = wrap.querySelector('[data-sbsl-perday]');
    if (!ex) {
      var d = document.createElement('div');
      d.setAttribute('data-sbsl-perday', '');
      d.textContent = txt;
      d.style.cssText = 'order: 3; flex-basis: 100%; width: 100%; text-align: right; font-size: 12px; line-height: 1.2; color: var(--sbsl-muted, #929495); margin-top: -3px;';
      wrap.appendChild(d);
    } else if (ex.textContent !== txt) {
      ex.textContent = txt;
    }
  }
  // Subtitle under the option title (Grüns-style). The option `label` is a flex column
  // (title row, then the absolutely-positioned prices); the prices block now has 2 lines
  // (price + per-day), so the title needs a 2nd line too or the columns don't align.
  // Inject the subtitle right after the selector. Idempotent.
  var SBSL_SUB_SUBTITLE = 'Delivers Every 4 weeks';
  var SBSL_ONETIME_SUBTITLE = 'Delivered once';
  var SBSL_ONETIME_NEGATIVES = ['No Free Shipping', 'No Free Gifts'];
  function injectSubtitle(selectorEl, text) {
    if (!selectorEl) return;
    var label = selectorEl.parentElement;
    if (!label || !label.querySelector) return;
    var ex = label.querySelector('[data-sbsl-subtitle]');
    if (!ex) {
      var d = document.createElement('div');
      d.setAttribute('data-sbsl-subtitle', '');
      d.textContent = text;
      d.style.cssText = 'font-size: 13px; color: var(--sbsl-muted, #929495); line-height: 1.2; margin-top: 3px; margin-left: 28px;';
      if (selectorEl.nextSibling) label.insertBefore(d, selectorEl.nextSibling); else label.appendChild(d);
    } else if (ex.textContent !== text) {
      ex.textContent = text;
    }
  }
  // Grüns-style "you lose this" bullets under the one-time option. Hangs off the same
  // `label` flex column as injectSubtitle, BELOW the 'Delivered once' subtitle. Create-once
  // only (copy is static), so it never re-writes text and never loops the characterData
  // observer. Red ✕ marker only (#c0392b danger red — NOT brand coral #f36f40 = action).
  function injectOnetimeNegatives(selectorEl) {
    if (!selectorEl) return;
    var label = selectorEl.parentElement;
    if (!label || !label.querySelector) return;
    // Selected-state signal: primary = the one-time radio's .checked; fallback = the
    // wrapper's rc-selected attr (only when no radio is found). wrapper = selector → label → div.
    var wrap = selectorEl.parentElement && selectorEl.parentElement.parentElement;
    var radio = wrap && wrap.querySelector('input[value="onetime"]');
    var selected = radio ? !!radio.checked : !!(wrap && wrap.hasAttribute('rc-selected'));
    // Create-once, idempotent: if the ul already exists, only toggle visibility (style.display
    // is NOT observed by observeAll → no loop) and return.
    var ul = label.querySelector('[data-sbsl-onetime-neg]');
    if (ul) { ul.style.display = selected ? 'flex' : 'none'; return; }
    // Font-match the adjacent subtitle (harness Recharge rule): same line-height grid,
    // one step smaller than the 13px subtitle so the negatives read quieter.
    var subt = label.querySelector('[data-sbsl-subtitle]');
    var lh = '1.2';
    if (subt) { var cs = getComputedStyle(subt); if (cs && cs.lineHeight) lh = cs.lineHeight; }
    ul = document.createElement('ul');
    ul.setAttribute('data-sbsl-onetime-neg', '');
    ul.style.cssText = 'list-style:none; margin:4px 0 0; margin-left:28px; padding:0; ' +
      'display:none; flex-direction:row; flex-wrap:wrap; gap:4px 16px; font-size:12px; line-height:' + lh + ';';
    SBSL_ONETIME_NEGATIVES.forEach(function (txt) {
      var li = document.createElement('li');
      li.style.cssText = 'display:flex; align-items:flex-start; gap:6px; color:#383d3f;';
      var mark = document.createElement('span');
      mark.style.cssText = 'color:#c0392b; flex:0 0 auto; font-weight:700;';
      mark.textContent = '✕';   // ✕
      var t = document.createElement('span');
      t.textContent = txt;
      li.appendChild(mark);
      li.appendChild(t);
      ul.appendChild(li);
    });
    label.appendChild(ul);
    ul.style.display = selected ? 'flex' : 'none';
  }
  // Deliveries per year from the selected frequency (drives the annual-savings bullet).
  function deliveriesPerYear(host) {
    var s = deep(host.shadowRoot, function (e) { return e.tagName === 'SELECT'; })[0];
    var txt = s && s.selectedOptions && s.selectedOptions[0] ? s.selectedOptions[0].textContent : '';
    var m = txt.match(/(\d+)\s*(day|week|month)/i);
    if (!m) return 0;
    var n = parseInt(m[1], 10);
    if (!n) return 0;
    var unit = m[2].toLowerCase();
    if (unit === 'day') return 365 / n;
    if (unit === 'week') return 52 / n;
    return 12 / n;   // month
  }

  function apply(host) {
    var orig = deep(host.shadowRoot, function (e) { return partHas(e, 'rc-purchase-option__original-price'); })[0];
    var disc = deep(host.shadowRoot, function (e) { return partHas(e, 'rc-purchase-option__discounted-price'); })[0];
    var sel  = deep(host.shadowRoot, function (e) { return partHas(e, 'rc-purchase-option__selector_subscription'); })[0];
    if (!sel) return false;

    // OUR per-variant first-order price from the Liquid carrier — the source of
    // truth for the displayed subscribe price. foStr is the exact money string to
    // inject; fo is the number that drives the savings/banner math. Read here (not
    // later) so the price logic no longer depends on Recharge's disc/orig nodes.
    var card = document.getElementById('sbsl-onetime-price');
    var foStr = card && card.getAttribute('data-first-order');
    var fo = foStr ? parseFloat(foStr.replace(/[^0-9.]/g, '')) : NaN;
    // Our price is the source of truth; if the carrier is missing (no #sbsl-onetime-price
    // on the page), bail BEFORE any mutation and leave Recharge's native card intact —
    // never inject a "$NaN" price. On a real PDP the carrier is always rendered.
    if (isNaN(fo)) return false;
    var cmp = card && card.getAttribute('data-compare');
    var cmpNum = cmp ? parseFloat(cmp.replace(/[^0-9.]/g, '')) : NaN;

    // Hide Recharge's "Save 20%" badge — replaced by the MOST POPULAR banner below.
    // display:none is idempotent (Recharge re-renders the badge each apply() run).
    deep(host.shadowRoot, function (e) { return partHas(e, 'rc-purchase-option__badge'); })
      .forEach(function (b) { b.style.display = 'none'; });

    // Remove the plans dropdown (reachable only by class, not a part).
    deep(host.shadowRoot, function (e) { return e.classList && e.classList.contains('rc-plans-dropdown'); })
      .forEach(function (el) { el.style.display = 'none'; });

    // o = MSRP-ish anchor for the savings math; d = the DISPLAYED sale price = OUR
    // first-order value. Neither calls priceOf on a guaranteed node: o falls back
    // (orig → compare-at → fo) and d falls back (fo → disc → o), so the card renders
    // even when Recharge drops its __original-price/__discounted-price nodes (0% plan).
    var o = orig ? priceOf(orig) : (cmpNum || fo);
    var d = !isNaN(fo) ? fo : (disc ? priceOf(disc) : o);

    // MOST POPULAR banner — full-width strip injected as the FIRST child of the
    // subscribe card, bleeding to the card edges. % computed from MSRP vs the
    // displayed subscribe price (= 41% today). Only when there's a real MSRP above
    // the sale price; create-once marked node + guarded text write (observer-safe).
    var subCardEl = deep(host.shadowRoot, function (e) { return partHas(e, 'rc-purchase-option__subscription'); })[0];
    if (subCardEl && cmp && cmpNum > d) {
      var bannerPct = Math.round((cmpNum - d) / cmpNum * 100);
      var bannerText = 'MOST POPULAR · GET ' + bannerPct + '% OFF';
      var banner = subCardEl.querySelector('[data-sbsl-banner]');
      if (!banner) {
        banner = document.createElement('div');
        banner.setAttribute('data-sbsl-banner', '');
        banner.style.cssText = 'display:block; margin:-10px -18px 10px; border-radius:4px 4px 0 0; padding:6px 12px; background:#f7ece1; color:#2f6f68; border-bottom:1px solid #ecdccd; text-align:center; font-size:13px; font-weight:800; letter-spacing:.08em; text-transform:uppercase;';
        banner.textContent = bannerText;
        subCardEl.insertBefore(banner, subCardEl.firstChild);
      }
      if (banner.textContent !== bannerText) banner.textContent = bannerText;
    }

    // Price emphasis (Grüns-style): the sale price leads, large + bold; the struck
    // price follows, smaller + muted, baseline-aligned. Flex `order` reorders without
    // moving DOM (the wrapper is already flex); style-only writes don't trip the observer.
    // Derive the price wrapper defensively — at a 0% selling plan Recharge may drop
    // BOTH __original-price and __discounted-price, so fall back to the __prices /
    // __subscription container. We own the displayed price now, so it must resolve
    // without either price node.
    var subWrap = (orig && orig.parentNode)
      || (disc && disc.parentNode)
      || deep(host.shadowRoot, function (e) { return partHas(e, 'rc-purchase-option__prices'); })[0]
      || deep(host.shadowRoot, function (e) { return partHas(e, 'rc-purchase-option__subscription'); })[0];
    if (subWrap && subWrap.style) {
      subWrap.style.display = 'flex';
      subWrap.style.alignItems = 'baseline';
      subWrap.style.flexWrap = 'wrap';
      subWrap.style.justifyContent = 'flex-end';   // right-align the price line so it shares the per-day's right edge
      subWrap.style.columnGap = '6px';
    }
    // Hide Recharge's own price nodes — we render our own first-order price below.
    // Both hides are style-only + existence-guarded (idempotent, observer-safe).
    if (disc) disc.style.display = 'none';
    if (orig) orig.style.display = 'none';
    // Inject OUR first-order price (create-once + diffed text) — the visible price.
    if (subWrap) {
      var priceEx = subWrap.querySelector('[data-sbsl-sub-price]');
      if (!priceEx) {
        var ps = document.createElement('span');
        ps.setAttribute('data-sbsl-sub-price', '');
        ps.style.cssText = 'order: 1; font-size: 20px; line-height: 1.2; font-weight: 700;';
        ps.textContent = foStr || ('$' + d.toFixed(2));
        subWrap.appendChild(ps);
      } else if (foStr && priceEx.textContent !== foStr) {
        priceEx.textContent = foStr;
      }
    }
    if (cmp) {
      // Strike against the MSRP, not Recharge's list price ($59, where its 20% is
      // computed). Inject our own struck MSRP from the carrier (mirrors the one-time
      // approach). Recharge's own orig strike is already hidden above.
      var subEx = subWrap && subWrap.querySelector('[data-sbsl-sub-compare]');
      if (subWrap && !subEx) {
        var ss = document.createElement('s');
        ss.setAttribute('data-sbsl-sub-compare', '');
        ss.textContent = cmp;
        ss.style.cssText = 'order: 2; color: var(--sbsl-muted, #929495); text-decoration: line-through; font-weight: 400; font-size: 14px; line-height: 1.2; margin: 0;';
        subWrap.appendChild(ss);
      } else if (subEx && subEx.textContent !== cmp) {
        subEx.textContent = cmp;
      }
    }
    injectPerDay(subWrap, d);   // d = subscribe sale price
    injectSubtitle(sel, SBSL_SUB_SUBTITLE);   // balances the 2-line price block

    // The MOST POPULAR banner is a flow child of the card; it pushed the title down,
    // but the prices wrapper is position:absolute (anchored to the card) so it didn't
    // follow → title sat below the price. Nudge the prices down by the measured gap to
    // re-align. Measured once (flag-guarded → no oscillation); attribute writes aren't
    // observed → no loop. Re-measures if Recharge re-renders the wrapper (flag gone).
    var bnr = deep(host.shadowRoot, function (e) { return e.hasAttribute && e.hasAttribute('data-sbsl-banner'); })[0];
    var priceNode = subWrap && subWrap.querySelector('[data-sbsl-sub-price]');
    if (bnr && subWrap && sel && priceNode && !subWrap.hasAttribute('data-sbsl-aligned')) {
      // Anchor to OUR injected price node (the real visible price); disc is now hidden
      // (zeroed rect) or absent, so measuring it would mis-align or throw. priceNode in
      // the guard also makes the block a no-op when injection was skipped.
      var dy = Math.round(sel.getBoundingClientRect().top - priceNode.getBoundingClientRect().top);
      // transform (not margin) — margin is ignored on this top-anchored absolute wrapper.
      if (dy > 0) { subWrap.style.transform = 'translateY(' + dy + 'px)'; subWrap.setAttribute('data-sbsl-aligned', ''); }
    }

    // Overwrite Recharge's own title text node with our title. Recharge's label
    // field rejects "&", so we render "Subscribe & Save" here. (The savings
    // amount lives in the benefits bullet, not the heading.)
    var titleText = 'Subscribe & Save';
    var legacy = sel.querySelector('[data-sbsl-savings]');   // clean up the old span approach
    if (legacy) legacy.remove();
    var tNode = null;
    for (var ti = 0; ti < sel.childNodes.length; ti++) {
      var cn = sel.childNodes[ti];
      if (cn.nodeType === 3 && cn.nodeValue.trim()) { tNode = cn; break; }
    }
    if (tNode && tNode.nodeValue !== titleText) tNode.nodeValue = titleText;

    // Custom benefits — replace the app's stock checkmark list with our own bullets.
    var sub = deep(host.shadowRoot, function (e) { return partHas(e, 'rc-purchase-option__sub-container'); })[0];
    var tpl = document.getElementById('sbsl-sub-benefits');
    if (sub && tpl) {
      // Hide the app's benefits list.
      deep(host.shadowRoot, function (e) { return partHas(e, 'rc-benefits__list'); })
        .forEach(function (el) { el.style.display = 'none'; });
      // Inject our list (+ its scoped <style>) once into this sub-container.
      var mine = sub.querySelector('.subscription-widget-facade--selling-points');
      if (!mine) {
        var frag = tpl.content.cloneNode(true);
        mine = frag.querySelector('.subscription-widget-facade--selling-points');
        sub.insertBefore(frag, sub.firstChild);
      }
      // Discount % (from prices). Guard the write — re-setting textContent fires
      // the observer and would loop forever.
      var pct = mine.querySelector('[data-sbsl-discount]');
      if (pct) {
        // MSRP-based % when there's a compare-at (matches the banner = 41%);
        // fall back to the real list discount for non-MSRP products.
        var pctNum = (cmp && cmpNum > d)
          ? Math.round((cmpNum - d) / cmpNum * 100)
          : Math.round((o - d) / o * 100);
        var pctLi = pct.closest('li');
        if (pctNum > 0) {
          var pctText = pctNum + '%';
          if (pct.textContent !== pctText) pct.textContent = pctText;
          if (pctLi && pctLi.style.display === 'none') pctLi.style.display = '';
        } else if (pctLi && pctLi.style.display !== 'none') {
          // No discount (0%, no MSRP) → hide the bullet rather than show "0%".
          pctLi.style.display = 'none';
        }
      }
      // Annual savings = per-order saving x deliveries/year; hide the bullet if unknown.
      var ann = mine.querySelector('[data-sbsl-annual]');
      if (ann) {
        var py = deliveriesPerYear(host);
        var li = ann.closest('li');
        var save = o - d;
        if (py && save > 0) {
          var annText = '$' + (save * py).toFixed(2);
          if (ann.textContent !== annText) ann.textContent = annText;
          if (li && li.style.display === 'none') li.style.display = '';
        } else if (li && li.style.display !== 'none') {
          // No positive per-order saving (0% / no-MSRP, or unparseable) → hide rather than show $0.00/$NaN.
          li.style.display = 'none';
        }
      }
    }

    // One-time compare-at strikethrough — inject `~~$79.99~~ $59.00` before the
    // one-time price. Per-product from the Liquid carrier; skip entirely (return the
    // subscribe result, no injection) when there's no compare-at. Kept LAST so the
    // subscribe logic above always runs regardless of one-time state.
    if (cmp) {
      // The one-time __price is the one whose parent __prices wrapper has NO
      // __original-price descendant (the subscribe wrapper HAS one). Robust to order.
      // Match the EXACT part token (partHas is substring, which also matches the
      // plural `rc-purchase-option__prices` wrapper — we want only the price span).
      var partExactly = function (e, tok) {
        var p = e.getAttribute && e.getAttribute('part');
        return p && (' ' + p + ' ').indexOf(' ' + tok + ' ') !== -1;
      };
      var oneTime = deep(host.shadowRoot, function (e) { return partExactly(e, 'rc-purchase-option__price'); })
        .filter(function (priceSpan) {
          var w = priceSpan.parentNode;
          if (!w || !w.querySelectorAll) return false;
          return deep(w, function (x) { return partHas(x, 'rc-purchase-option__original-price'); }).length === 0;
        });
      // Exactly one one-time candidate must survive; if none, the widget isn't ready —
      // the observer/retry will re-run apply(). Bail without touching the subscribe wrapper.
      if (oneTime.length === 1 && oneTime[0].parentNode) {
        var priceSpan = oneTime[0];
        var wrap = priceSpan.parentNode;
        // Match the subscribe treatment: sale price leads large + bold, MSRP follows
        // smaller + muted + struck. Flex `order` controls layout, so the injected <s>
        // can stay before the price in the DOM. Baseline-align the differing sizes.
        if (wrap.style) {
          wrap.style.display = 'flex';
          wrap.style.alignItems = 'baseline';
          wrap.style.flexWrap = 'wrap';
          wrap.style.justifyContent = 'flex-end';   // right-align the price line to the per-day's right edge
          wrap.style.columnGap = '6px';
        }
        priceSpan.style.order = '1'; priceSpan.style.fontSize = '20px'; priceSpan.style.lineHeight = '1.2';
        var existing = wrap.querySelector('[data-sbsl-onetime-compare]');
        if (!existing) {
          var s = document.createElement('s');
          s.setAttribute('data-sbsl-onetime-compare', '');
          s.textContent = cmp;
          s.style.cssText = 'order: 2; color: var(--sbsl-muted, #929495); text-decoration: line-through; font-weight: 400; font-size: 14px; line-height: 1.2; margin: 0;';
          wrap.insertBefore(s, priceSpan);
        } else if (existing.textContent !== cmp) {
          existing.textContent = cmp;
        }
        injectPerDay(wrap, priceOf(priceSpan));   // one-time sale price
        var otSel = deep(host.shadowRoot, function (e) { return partExactly(e, 'rc-purchase-option__selector_onetime'); })[0];
        injectSubtitle(otSel, SBSL_ONETIME_SUBTITLE);
        injectOnetimeNegatives(otSel);
      }
    }
    return true;
  }

  function observeAll(root, cb) {
    new MutationObserver(cb).observe(root, { childList: true, subtree: true, characterData: true });
    root.querySelectorAll('*').forEach(function (e) { if (e.shadowRoot) observeAll(e.shadowRoot, cb); });
  }

  function init() {
    var host = document.querySelector('.single-pro recharge-subscription-widget');
    if (!host || !host.shadowRoot) return false;
    if (!apply(host)) return false;
    // Re-run when the widget re-renders (e.g. the "Deliver every" dropdown changes
    // the discount). Observe every shadow root so nested price updates are caught.
    observeAll(host.shadowRoot, function () { apply(host); });
    return true;
  }

  var tries = 0;
  var timer = setInterval(function () { if (init() || ++tries > 40) clearInterval(timer); }, 250);
})();
